import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {QuestionReport} from '../incase-domain/analytics';
import {roomRunFileSelector, roomSelector} from '../store/selectors/roomRunFile.selectors';
import {questionReportsSelector} from '../store/selectors/analytics.selectors';
import {fetchQuestionReportAction, updateQuestionReportAction} from '../store/actions/analytics.actions';
import {socket} from '../util/socket';

export function useQuestionReportData(questionElementId: string | undefined, refreshKey?: string): QuestionReport | undefined {
    const dispatch = useDispatch();
    const room = useSelector(roomSelector);
    const roomRunFile = useSelector(roomRunFileSelector);
    const questionReports = useSelector(questionReportsSelector);

    const inRoom = !!room.roomId;
    const reportRefreshKey = inRoom ? undefined : refreshKey;

    useEffect(() => {
        if (!inRoom || !questionElementId || !roomRunFile._id || !socket) {
            return undefined;
        }

        const eventName = `questionReport-${questionElementId}`;
        const handler = (report: QuestionReport): void => {
            dispatch(updateQuestionReportAction(report));
        };

        socket.emit('subscribeQuestionReport', {
            questionId: questionElementId,
            roomRunfileId: roomRunFile._id,
        });
        socket.on(eventName, handler);

        return () => {
            socket?.emit('unsubscribeQuestionReport', {questionId: questionElementId});
            socket?.off(eventName, handler);
        };
    }, [dispatch, inRoom, questionElementId, roomRunFile._id]);

    useEffect(() => {
        if (!questionElementId) {
            return;
        }

        if (inRoom) {
            if (!roomRunFile._id) {
                return;
            }

            dispatch(fetchQuestionReportAction(questionElementId, roomRunFile._id));
            return;
        }

        dispatch(fetchQuestionReportAction(questionElementId));
    }, [dispatch, inRoom, questionElementId, reportRefreshKey, roomRunFile._id]);

    return questionReports.find((qr) => qr.elementId === questionElementId);
}
